import request from "@helpers/request";

function fetchSectors(config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/atoll/sector_json`, {}, { ...config });
}

function fetchKpis(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .post(`/v1/atoll/kpi_json`, params, { ...config, responseType: "blob" });
}

function fetchLogs(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`/v1/atoll/logs`, params, { ...config });
}

function fetchRoles(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`/v1/atoll/roles`, params, { ...config });
}

function fetchErrors(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`/v1/atoll/errors`, params, { ...config });
}

function fetchAccess(params, config) {
  return request
    .forBaseUrl()
    .withHeaders({ "Content-Type": "application/json" })
    .build()
    .get(`/v1/atoll/access`, params, { ...config });
}

const atollService = {
  fetchSectors,
  fetchKpis,
  fetchLogs,
  fetchRoles,
  fetchErrors,
  fetchAccess,
};

export default atollService;
